<template>
  <modal
    name="property-image-upload"
    :classes="'customModal image__upload__modal'"
    :scrollable="true"
    :reset="true"
    :adaptive="false"
    :width="570"
    height="auto"
    :clickToClose="false"
  >
    <div class="modalWrapper">
      <div class="form-row mb-4">
        <div class="col-12">
          <div class="content__box">
            <div class="content__box__body">
              <div class="top__filter">
                <ul class="top__filter__ul mb-3">
                  <li v-if="!sview" class="mb-0 txt--semi-bold">Photos</li>
                  <li v-if="sview" class="mb-0 txt--semi-bold">Street View</li>
                </ul>
              </div>

              <div v-if="!sview" class="form-row">
                <div class="col-12">
                  <div class="property__image__prev mb-3" v-if="img_preview">
                    <img :src="img_preview" class="w-100" alt="Image" />
                  </div>
                </div>
              </div>

              <div v-if="!sview" class="form-row align-items-center">
                <div class="col-6 col-sm-3">
                  <fileUpload
                    :property_image="files.length > 0 ? files[0] : ''"
                    :index="0"
                    @change:image="getImage($event, 0)"
                    @streetViewcomp="showStreetview($event)"
                    @delete_image="deleteImage($event)"
                    @image_to_view="imageToView($event)"
                  />
                </div>
                <div class="col-6 col-sm-3">
                  <fileUpload
                    :property_image="files.length > 1 ? files[1] : ''"
                    :index="1"
                    @change:image="getImage($event, 1)"
                    @streetViewcomp="showStreetview($event)"
                    @delete_image="deleteImage($event)"
                    @image_to_view="imageToView($event)"
                  />
                </div>
                <div class="col-6 col-sm-3 mt-3 mt-sm-0">
                  <fileUpload
                    :property_image="files.length > 2 ? files[2] : ''"
                    :index="2"
                    @change:image="getImage($event, 2)"
                    @streetViewcomp="showStreetview($event)"
                    @delete_image="deleteImage($event)"
                    @image_to_view="imageToView($event)"
                  />
                </div>
                <div class="col-6 col-sm-3 mt-3 mt-sm-0">
                  <fileUpload
                    :index="3"
                    :property_image="files.length > 3 ? files[3] : ''"
                    @change:image="getImage($event, 3)"
                    @streetViewcomp="showStreetview($event)"
                    @delete_image="deleteImage($event)"
                    @image_to_view="imageToView($event)"
                  />
                </div>
                <div class="col-sm-3 mt-3">
                  <fileUpload
                    :index="4"
                    :property_image="files.length > 4 ? files[4] : ''"
                    @change:image="getImage($event, 4)"
                    @streetViewcomp="showStreetview($event)"
                    @delete_image="deleteImage($event)"
                    @image_to_view="imageToView($event)"
                  />
                </div>
              </div>
              <div v-if="sview" class="form-row">
                <div class="col-12" style="height:195px;">
                  <streetview
                    :street_location="panaroma_coordinates"
                    :pitch="camera_pitch"
                    :zoom="camera_zoom"
                    :heading="camera_heading"
                    @get_image="getStreetViewImage"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="user_role == 'commercial' || (user_role == 'operator' && access_list.permit_access_write == true)" >
        <div v-if="!sview" class="form-row">
          <div class="col-12">
            <div class="d-flex justify-content-center flex-wrap">
              <button
                type="button"
                class="button button--primary button--sm mr-3"
                :disabled="save_btn_disabled"
                @click="savePropertyImage()"
              >Save</button>
              <button
                type="button"
                class="button button--outline button--sm"
                @click="closeModal()"
              >Cancel</button>
            </div>
          </div>
        </div>
        <div v-if="sview" class="form-row">
          <div class="col-12">
            <div class="d-flex justify-content-center flex-wrap">
              <button
                type="button"
                class="button button--primary button--sm mr-3"
                @click="getSnapShot()"
              >Take Snapshot</button>
              <button
                type="button"
                class="button button--outline button--sm"
                @click="sview = false"
              >Cancel</button>
            </div>
          </div>
        </div>
      </div>
      <div class="session__modal__close" @click="closeModal()">
        <i class="fas fa-times"></i>
      </div>
    </div>
  </modal>
</template>

<script>
import FileUpload from "@/components/fileUpload";
import streetview from "@/components/streetView";

export default {
  name: "PropertyImageUpload",
  props: ["property_details"],
  data() {
    return {
      files: [],
      fileIndex: 0,
      img_preview : null,
      save_btn_disabled: false,
      sview: false,
      panaroma_coordinates: { lat: null, lng: null },
      camera_pitch: 10,
      camera_zoom: 1,
      camera_heading: 34,
      street_view_index: 1,
      street_view : null ,
      user_role:    '',
      access_list:  {},
    };
  },
  components: {
    fileUpload: FileUpload,
    streetview: streetview
  },
  created() {
    this.user_role    = localStorage.getItem("role");
    this.access_list  = JSON.parse(localStorage.getItem("commercial_access_list"));

    this.files = this.property_details.photo.images;
    if(this.files.length > 0)
    {
      this.img_preview = this.files[0];
    }

    this.camera_pitch = this.property_details.location.camera_pitch ? this.property_details.location.camera_pitch : 10;
    //populate camera zoom
    this.camera_zoom = this.property_details.location.camera_zoom ? this.property_details.location.camera_zoom : 1;
    //populate camera heading
    this.camera_heading = this.property_details.location.camera_heading
      ? this.property_details.location.camera_heading
      : 34;
    //populate panarom coordinates

    this.panaroma_coordinates.lat = this.property_details.location
      .panorama_latitude
      ? this.property_details.location.panorama_latitude
      : null;
    this.panaroma_coordinates.lng = this.property_details.location
      .panorama_longitude
      ? this.property_details.location.panorama_longitude
      : null;
  },
  computed: {
    computeModalWidth() {
      if (this.$mq === "lg") return "900px";
      else return "400px";
    }
  },
  methods: {
    imageToView(e) {
      this.fileIndex = e;
      if(this.files[this.fileIndex] instanceof File)
      {
        this.img_preview = URL.createObjectURL(this.files[this.fileIndex]);
      }
      else
      {
        this.img_preview = this.files[this.fileIndex];
      }
    },
    async showStreetview(e) {
      let location = this.property_details.location;
      if (
        location.panorama_latitude != "" &&
        location.panorama_longitude != ""
      ) {
        this.panaroma_coordinates.lat = location.panorama_latitude;
        this.panaroma_coordinates.lng = location.panorama_longitude;
      } else if (
        location.entrance_latitude != "" &&
        location.entrance_longitude != ""
      ) {
        this.panaroma_coordinates.lat = location.entrance_latitude;
        this.panaroma_coordinates.lng = location.entrance_longitude;
      } else if (location.latitude != "" && location.longitude) {
        this.panaroma_coordinates.lat = location.latitude;
        this.panaroma_coordinates.lng = location.longitude;
      } else {
        this.$toasted.show("Please select a proper location first!", {
          icon: "times-cirlce",
          className: "error-class"
        });
        return;
      }
      if (location.camera_heading) {
        this.camera_heading = location.camera_heading;
      }
      if (location.camera_pitch) {
        this.camera_pitch = location.camera_pitch;
      }
      if (location.camera_zoom) {
        this.camera_zoom = location.camera_zoom;
      }
      this.sview = e.show_street;
      //============ Check If StreetView Exists ================//
      this.street_view = new window.google.maps.StreetViewService();
      const self = this;
      let myLatlng = new window.google.maps.LatLng(this.panaroma_coordinates.lat, this.panaroma_coordinates.lng);
      await this.street_view.getPanorama(
        {
          location: myLatlng,
          radius: 100,
          source: window.google.maps.StreetViewSource.OUTDOOR
        },
        function(data, status) {
          console.log('outdoor',data,status,window.google.maps.StreetViewStatus.OK);
          if (status == window.google.maps.StreetViewStatus.OK) {
            self.sview = e.show_street;
            self.street_view_index = e.index;
          } else {
            self.$toasted.show(
              "This location has no outdoor street view available!",
              {
                icon: "times-circle",
                className: "error-class"
              }
            );
          }
        }
      );
      
    },
    closeModal() {
      this.$emit("modal_closed");
      this.$modal.hide("property-image-upload");
    },
    getImage(event, index) {
      this.files[index] = event;
      // this.imageToView(index);
    },
    getSnapShot() {
      window.EventBus.$emit("take_a_snap");
      this.sview = false;
    },
    getStreetViewImage(e) {
      console.log(e);
      this.files[this.street_view_index] = e;
    },
    deleteImage(event) {
      let image = "";
      console.log(typeof(this.files[event]));
      if(typeof(this.files[event]) == 'object')
      {
        console.log('here');
        this.$delete(this.files,event);
        this.$toasted.show('Image removed successfully!', {
          icon: "check-circle",
          className: "success-class"
        });
        this.closeModal();
        return ;
      }
      if (
        this.files[event].indexOf(
          "https://maps.googleapis.com/maps/api/streetview"
        ) == -1
      ) {
        let imageArr = this.files[event].split("/");
        image = imageArr[imageArr.length - 1];
      } else {
        image = this.files[event];
      }

      if (image) {
        this.axios
          .post(window.hostname + "api/auth/delete-image", {
            image: image,
            space_id: this.property_details.space_id
          })
          .then(res => {
            if (res.data.status) {
              this.$emit("modal_closed");
              this.$toasted.show(res.data.message, {
                icon: "check-circle",
                className: "success-class"
              });
            } else {
              this.$toasted.show(res.data.message, {
                icon: "times-circle",
                className: "error-class"
              });
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    savePropertyImage() {
      this.save_btn_disabled = true;

      this.formData = new FormData();
      this.formData.append("device_type", 1);
      this.formData.append("mode", "photo");
      if(this.files.length > 0)
      {
        // =========== Re index Files Array =============//
        this.files = this.files.filter(val => val);
        // console.log(this.files);
        // return false ;
      }
      else
      {
        this.$toasted.show('Atleast one image is required!',{
          icon : 'times-circle',
          className : 'error-class'
        });
        this.save_btn_disabled = false;
        return ;
      }
      for (let i = 0; i < this.files.length; i++) {
        this.formData.append("images[" + i + "]", this.files[i]);
      }

      this.formData.append("space_id", this.property_details.space_id);

      this.axios
        .post(window.hostname + "api/auth/create-space", this.formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(res => {
          this.save_btn_disabled = false;
          if (res.data.status) {
            this.$toasted.show("Property details updated successfully !", {
              icon: "check-circle",
              className: "success-class",
              timeout: 3000
            });
            this.closeModal();
          } else {
            this.$toasted.show(res.data.message, {
              className: "error-class",
              icon: "times-circle",
              timeout: 3000
            });
          }
        })
        .catch(err => {
          console.log(err);
          this.save_btn_disabled = false;
          this.$toasted.show("Something went wrong. Please try again !", {
            className: "error-class",
            icon: "times-circle",
            timeout: 3000
          });
        });
    }
  }
};
</script>

<style>
.vm--overlay {
  background: rgba(0, 0, 0, 0.9) !important;
}
/* .image__upload__modal.vm--modal {
  overflow: auto;
} */
</style>
